<div appSwipe (onSwipe)="onSwipeDown($event)">
  <app-google-one-tap></app-google-one-tap>
  <router-outlet></router-outlet>

  <app-dialogs></app-dialogs>
  <!-- e2e test doesn't like it when this is loaded later-->
  @defer (on idle) {
  <app-tooltip-global></app-tooltip-global>
  <app-toasts></app-toasts>
  <app-mobile-menus></app-mobile-menus>
  <app-context-menu-global></app-context-menu-global>
  <app-route-loader [active]="routeLoading"></app-route-loader>
  } @defer (when showCookieBanner) {
  <app-cookie-banner *ngIf="showCookieBanner" (onHide)="hideCookieBanner()"></app-cookie-banner>
  } @defer (when showServerTiming) {
  <app-server-timing *ngIf="showServerTiming"></app-server-timing>
  }
</div>
